
import React, { useContext, useMemo } from 'react';
import { mockRecommendedGroups } from '../mockData';
// FIX: Changed import to correct PageContext file to avoid circular dependency
import { PageContext } from '../PageContext';
import { Page, GroupGame } from '../types';
import BackButton from '../components/BackButton';
import { useAuth } from '../AuthContext';

const RecommendedGroupCard: React.FC<{ group: GroupGame, onJoin: (group: GroupGame) => void }> = ({ group, onJoin }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm p-4 flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-3 sm:space-y-0">
            <img src={group.imageUrl} alt={group.name} className="w-full sm:w-24 h-24 sm:h-24 object-cover rounded-md" />
            <div className="flex-1">
                <h3 className="font-bold text-lg text-gray-800">{group.name}</h3>
                <p className="text-sm text-gray-500">{group.description}</p>
                <p className="text-xs text-gray-400 mt-1">{group.members.length} members</p>
            </div>
            <button
                onClick={() => onJoin(group)}
                className="w-full sm:w-auto bg-[var(--primary-dark-purple)] text-white font-bold py-2 px-4 rounded-lg text-sm shadow-md"
            >
                Join
            </button>
        </div>
    );
};

const RecommendedGroupsPage: React.FC = () => {
    const pageContext = useContext(PageContext);
    const { requestToJoinGroup, joinGame } = useAuth();

    const recommendedGroups = mockRecommendedGroups;

    const groupsWithAds = useMemo(() => {
        return recommendedGroups;
    }, [recommendedGroups]);

    const handleJoinGroup = (group: GroupGame) => {
        if (group.privacy === 'public') {
            joinGame(group.id);
            pageContext?.switchPage(Page.GameDetail, group.name, { gameId: group.id });
        } else {
            requestToJoinGroup(group.id);
            alert(`Request sent to join ${group.name}!`);
        }
    };

    return (
        <div className="space-y-4">
            <BackButton text="Back Home" />
            <h2 className="text-2xl font-bold">
                <span className="aurora-text">Recommended Groups</span>
            </h2>
            <div className="space-y-3">
                {groupsWithAds.map(item => {
                    return (
                        <RecommendedGroupCard
                            key={item.id}
                            group={item as GroupGame}
                            onJoin={handleJoinGroup}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default RecommendedGroupsPage;
